import { render, staticRenderFns } from "./closeshop.vue?vue&type=template&id=635dc076&scoped=true"
import script from "./closeshop.vue?vue&type=script&lang=js"
export * from "./closeshop.vue?vue&type=script&lang=js"
import style0 from "./closeshop.vue?vue&type=style&index=0&id=635dc076&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635dc076",
  null
  
)

export default component.exports